export default __webpack_public_path__ + "static/media/quote svg.51de3c8d.svg";